function initClarity() {
  (function (c, l, a, r, i, t, y) {
    c[a] = c[a] || function () { (c[a].q = c[a].q || []).push(arguments); };
    t = l.createElement(r); t.async = 1;
    t.src = 'https://www.clarity.ms/tag/' + i;
    y = l.getElementsByTagName(r)[0];
    y.parentNode.insertBefore(t, y);
  })(window, document, 'clarity', 'script', 'scnozsij8u');
}

window.addEventListener('load', function () {
  (window.requestIdleCallback || function (cb) { setTimeout(cb, 200); })(initClarity, { timeout: 3000 });
});

// Track cart add failures → GTM dataLayer → GA4
document.addEventListener('cart:error', function (event) {
  var form = event.target;
  var variantId = form && form.elements['id'] ? form.elements['id'].value : 'unknown';
  var productId = form && form.elements['product-id'] ? form.elements['product-id'].value : 'unknown';
  var productCard = form && form.closest('product-card');
  var productHandle = productCard ? productCard.getAttribute('handle') : 'unknown';

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'cart_add_error',
    error_message: event.detail && event.detail.error ? event.detail.error : 'unknown',
    variant_id: variantId,
    product_id: productId,
    product_handle: productHandle,
    page_url: window.location.href,
    page_path: window.location.pathname
  });
});

// === Synchronized Scroll — Product Page ===
function initProductSyncScroll() {
  var DESKTOP_MIN_WIDTH = 1000;
  var HEIGHT_THRESHOLD = 50; // px — ignore near-equal heights

  var section = document.querySelector('.shopify-section--main-product');
  if (!section) return;

  var product = section.querySelector('.product');
  var gallery = product && product.querySelector('.product-gallery');
  var info = product && product.querySelector('.product-info');
  if (!product || !gallery || !info) return;

  function update() {
    product.classList.remove('product--gallery-sticky', 'product--info-sticky');
    if (window.innerWidth < DESKTOP_MIN_WIDTH) return;
    var galleryH = gallery.scrollHeight;
    var infoH = info.scrollHeight;
    if (galleryH - infoH > HEIGHT_THRESHOLD) {
      product.classList.add('product--info-sticky');
    } else if (infoH - galleryH > HEIGHT_THRESHOLD) {
      product.classList.add('product--gallery-sticky');
    }
  }

  update();
  var ro = new ResizeObserver(update);
  ro.observe(gallery);
  ro.observe(info);
  window.addEventListener('resize', update);
}

// === Homepage Hero Parallax (GSAP ScrollTrigger) ===
function initHeroParallax() {
  if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;

  gsap.registerPlugin(ScrollTrigger);

  var heroSection = document.querySelector('#main > div');
  if (!heroSection) return;

  var heroImage = heroSection.querySelector('[class*="--image"]');
  var heroContent = heroSection.querySelector('[class*="--content-inner"]');

  // Image scrolls slower → creates depth (larger value = more obvious parallax)
  if (heroImage) {
    gsap.to(heroImage, {
      yPercent: 50,
      ease: 'none',
      scrollTrigger: {
        trigger: heroSection,
        start: 'top top',
        end: 'bottom top',
        scrub: 1.5
      }
    });
  }

  // Text drifts upward faster → reinforces the parallax separation
  if (heroContent) {
    gsap.to(heroContent, {
      yPercent: -40,
      ease: 'none',
      scrollTrigger: {
        trigger: heroSection,
        start: 'top top',
        end: 'bottom top',
        scrub: 1.5
      }
    });
  }
}

// === Variant Thumb Switcher — product card swatch click ===
document.addEventListener('click', function (e) {
  const thumb = e.target.closest ? e.target.closest('.variant-thumb') : null;
  if (!thumb) return;

  const card = thumb.closest ? thumb.closest('.product-card') : null;
  if (!card) return;

  const handle = thumb.dataset.variantHandle;
  if (!handle) return;

  const thumbsWrapper = thumb.closest ? thumb.closest('.variant-thumbs') : null;
  if (!thumbsWrapper) return;

  let selectorHandle = handle;

  if (window.CSS && typeof CSS.escape === 'function') {
    selectorHandle = CSS.escape(handle);
  } else {
    selectorHandle = handle.replace(/"/g, '\\"');
  }

  const template = thumbsWrapper.querySelector(
    'template[data-product-handle="' + selectorHandle + '"]'
  );

  if (!template) return;

  const script = template.content
    ? template.content.querySelector('script[type="application/json"]')
    : template.querySelector('script[type="application/json"]');

  if (!script) return;

  let data;

  try {
    data = JSON.parse(script.textContent.trim());
  } catch (err) {
    console.error('Invalid template JSON', err);
    return;
  }

  /* IMAGE */
  var img = card.querySelector('.product-card__image--primary') || card.querySelector('.product-card__media img');

  if (img && data.image) {
    var baseImageUrl = data.image.replace(/&width=\d+/, '');
    var newSrcset = [200, 300, 400, 500, 600, 700, 800, 1000, 1200, 1400, 1600, 1800].map(function(w) {
      return baseImageUrl + '&width=' + w + ' ' + w + 'w';
    }).join(', ');
    img.src = data.image;
    img.srcset = newSrcset;
  }

  /* LINKS */
  const mediaLink = card.querySelector('.product-card__media');
  if (mediaLink) mediaLink.href = data.url;

  const title = card.querySelector('.product-title');
  if (title) {
    title.textContent = data.title;
    title.href = data.url;
  }

  const shopNow = card.querySelector('.TextMaurice a');
  if (shopNow) shopNow.href = data.url;

  /* PRICE */
  const oldPrice = card.querySelector('.price-list');
  if (oldPrice && data.price_html) {
    const temp = document.createElement('div');
    temp.innerHTML = data.price_html;
    oldPrice.replaceWith(temp.firstElementChild);
  }

  /* VARIANT ID */
  const variantInput = card.querySelector('input[name="id"]');
  if (variantInput && data.variant_id) {
    variantInput.value = data.variant_id;
  }

  const quickBuyModal = card.querySelector('quick-buy-modal');
  if (quickBuyModal) {
    quickBuyModal.setAttribute('handle', handle);
  }

  /* ACTIVE STATE */
  card.querySelectorAll('.variant-thumb').forEach(function (el) {
    el.classList.remove('selected');
    var elImg = el.querySelector('img');
    if (elImg) elImg.style.borderBottom = 'none';
  });

  thumb.classList.add('selected');
  var thumbImg = thumb.querySelector('img');
  if (thumbImg) thumbImg.style.borderBottom = '3px solid white';

  /* RATING */
  var allRatings = card.querySelectorAll('.klaviyo-star-rating-widget');
  allRatings.forEach(function (el) { el.style.display = 'none'; });
  allRatings.forEach(function (el) {
    if (String(el.dataset.id) === String(data.product_id)) {
      el.style.display = 'block';
    }
  });

  /* BADGES — rebuild custom + sold-out in one pass */
  var figure = card.querySelector('.product-card__figure');
  var badgeList = card.querySelector('badge-list');

  if (!badgeList && figure) {
    badgeList = document.createElement('badge-list');
    badgeList.className = 'badge-list badge-list--vertical';
    figure.prepend(badgeList);
  }

  if (badgeList) {
    badgeList.innerHTML = '';

    if (data.badge) {
      var badges = Array.isArray(data.badge) ? data.badge : [data.badge];
      badges.forEach(function (text) {
        if (text && text.trim() !== '') {
          var span = document.createElement('span');
          span.className = 'badge badge--custom';
          span.textContent = text;
          badgeList.appendChild(span);
        }
      });
    }

    if (data.available === false) {
      var soldOutBadge = document.createElement('sold-out-badge');
      soldOutBadge.className = 'badge badge--sold-out';
      soldOutBadge.textContent = 'Sold out';
      badgeList.appendChild(soldOutBadge);
    }

    badgeList.hidden = badgeList.children.length === 0;
  }

  /* QUICK BUY — hide when sold out */
  var quickBuyButton = card.querySelector('.product-card__quick-add-button');
  if (quickBuyButton) {
    quickBuyButton.style.display = (data.available === false) ? 'none' : '';
  }
});

// === Variant Thumb Arrows — scroll arrow visibility ===
function updateVariantArrows(card) {
  const wrapper = card.querySelector('.variant-thumbs-wrapper');
  const leftArrow = card.querySelector('.arrow-left');
  const rightArrow = card.querySelector('.arrow-right');

  if (!wrapper || !leftArrow || !rightArrow) return;

  if (wrapper.scrollLeft > 0) {
    leftArrow.classList.remove('hidden-op');
  } else {
    leftArrow.classList.add('hidden-op');
  }

  if (wrapper.scrollLeft + wrapper.clientWidth < wrapper.scrollWidth - 1) {
    rightArrow.classList.remove('hidden-op');
  } else {
    rightArrow.classList.add('hidden-op');
  }
}

document.addEventListener('click', function (e) {
  const left = e.target.closest('.arrow-left');
  const right = e.target.closest('.arrow-right');
  if (!left && !right) return;

  const card = e.target.closest('product-card');
  const wrapper = card?.querySelector('.variant-thumbs-wrapper');
  if (!wrapper) return;

  wrapper.scrollBy({
    left: left ? -69 : 69,
    behavior: 'smooth',
  });

  setTimeout(function () { updateVariantArrows(card); }, 300);
});

document.addEventListener(
  'scroll',
  function (e) {
    const wrapper = e.target.closest?.('.variant-thumbs-wrapper');
    if (!wrapper) return;

    const card = wrapper.closest('product-card');
    if (card) updateVariantArrows(card);
  },
  true
);

document.addEventListener('DOMContentLoaded', function () {
  initProductSyncScroll();
  initHeroParallax();

  document.querySelectorAll('product-card').forEach(function (card) {
    updateVariantArrows(card);
  });

  document.querySelectorAll('ul.tabs').forEach(function (tabList) {
    var links = tabList.querySelectorAll('a');
    if (!links.length) return;

    var active = links[0];
    active.classList.add('active');
    var content = document.querySelector(active.getAttribute('href'));

    Array.from(links).slice(1).forEach(function (link) {
      var panel = document.querySelector(link.getAttribute('href'));
      if (panel) panel.style.display = 'none';
    });

    links.forEach(function (link) {
      link.addEventListener('click', function (e) {
        e.preventDefault();
        active.classList.remove('active');
        if (content) content.style.display = 'none';
        active = link;
        content = document.querySelector(link.getAttribute('href'));
        active.classList.add('active');
        if (content) content.style.display = '';
      });
    });
  });
});